enum Events {
  BuildingChanging = 'buildingChanging',
  BuildingColorChanged = 'buildingColorChanged',
  BuildingSelectionChanged = 'buildingSelectionChanged',
  ClipboardContentChanged = 'clipboardContentChanged',
  CurrentTenementChanged = 'currentTenementChanged',
  EntityAdded = 'entityAdded',
  LevelSelectionChanged = 'levelSelectionChanged',
  Model3DDeleted = 'model3DDeleted',
  PluAutoNumResultsChanged = 'pluAutoNumResultsChanged',
  PluAutoSelectedResultChanged = 'pluAutoSelectedResultChanged',
  PluCorrectionsChanged = 'pluCorrectionsChanged',
  PluRulesChanged = 'pluRulesChanged',
  RenderingStateChanged = 'renderingStateChanged',
  RoofChanged = 'roofChanged',
  RoofSelectionChanged = 'roofSelectionChanged',
  RuleCheckingResultAdded = 'ruleCheckingResultAdded',
  RuleCheckingToggle = 'ruleCheckingToggle',
  SimulationChanged = 'simulationChanged',
  ParkingOutputChanged = 'parkingOutputChanged',
  PluAutoConstructibilityChanged = 'pluAutoConstructibilityChanged',
  TenementsChanged = 'tenementsChanged',
  UndoMilestone = 'undoMilestone',
  UndoStateChanged = 'undoStateChanged',
  UserModifiedBuilding = 'userModifedBuilding',
  ConstructibilityBandsCacheUpdated = 'constructibilityBandsCacheUpdated',
  RuleCheckingInputHasChanged = 'ruleCheckingInputHasChanged',
  ParkingWasEdited = 'parkingWasEdited',
}

export default Events;
